module.exports = __webpack_public_path__ + "static/media/view.658c2b70.svg";